// extracted by mini-css-extract-plugin
module.exports = {"aboutContent":"About_about-content__2pblM","aboutDisposable":"About_about-disposable__3Fq6e"};